var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Fab as MuiFab } from '@mui/material';
import { StringUtils } from '../../utils';
export var FabButton = function (props) { return (_jsx(MuiFab, __assign({ className: StringUtils.combineStrings(['localina-fabbutton', props.className, props.fixed && 'position-fixed']), disabled: props.disabled, disableRipple: true, onClick: props.onClick }, { children: props.icon }))); };
